<template>
  <layout>
    <div>
      <b-card>
        <b-row>
          <b-col cols="2">
            <button type="button" class="btn btn-success" @click="refresh()">
              <i class="icon-refresh" />
              Refresh
            </button>
          </b-col>
          <b-col cols="5">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Type name to Search"
                type="text"
                id="myInput"
                @keyup="seachbyName()"
                title="Type in a name"
              />
            </b-input-group>
          </b-col>
          <b-col cols="5">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Type NIC to Search"
                type="text"
                id="myInput"
                @keyup="seachbyNIC()"
                title="Type in a name"
              />
            </b-input-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mt-4">
        <b-row class="mt-1 mb-3">
          <h2 style="margin-left: auto; margin-right: auto; color: #f33a3a;">
            Unpaid Members
          </h2>
        </b-row>

        <table class="table" id="TableList">
          <thead class="thead-dark">
            <tr>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">NIC</th>
              <th scope="col">Mobile No.</th>
              <th scope="col">Mobile No. 2</th>
              <th scope="col">Last Payment Date</th>
              <th scope="col">Joined Date</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(member, index) in members" :key="member._id">
              <td>{{ member.first_name }}</td>
              <td>{{ member.last_name }}</td>
              <td>{{ member.nic_no }}</td>
              <td>{{ member.mobile_no }}</td>
              <td>{{ member.mobile_no_2 }}</td>
              <td>{{ member.last_payment_date }}</td>
              <td>{{ member.joined_date }}</td>
              <td>{{ member.status }}</td>
              <!-- <td>
              <b-button
                :key="member._id"
                class="btn btn-info btn-md"
                @click="editMember(member)"
              >
                <i class="cui-pencil" />
                Edit
              </b-button>
            </td> -->
            </tr>
          </tbody>
        </table>
      </b-card>
    </div>
  </layout>
</template>

<script>
import Layout from '@layouts/main'
import { memberMethods } from '@state/helpers'

export default {
  name: 'unpaid',
  components: {
    Layout,
  },
  page: {
    title: 'Unpaid Members',
  },
  data() {
    return {
      members: [],
      filter: null,
      filterNIC: null,
      currentDate: new Date(),
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.loadMembers()
  },
  methods: {
    ...memberMethods,
    formattedDate() {
      const date = this.currentDate
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    async loadMembers() {
      let query = {
        selector: {
          type: 'member',
          next_payment_date: {
            $lt: this.formattedDate(),
          },
        },
        limit: 10000000,
      }
      let response = await this.getAllUnpaidMembers(query)
      debugger
      if (response.docs.length > 0) {
        this.members = response.docs
      } else {
        // notify to create a company first
      }
    },
    refresh() {
      this.loadMembers()
    },

    seachbyName() {
      var input, filter, table, tr, td, i, txtValue
      input = document.getElementById('myInput')
      filter = input.value.toUpperCase()
      table = document.getElementById('TableList')
      tr = table.getElementsByTagName('tr')
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName('td')[0]
        if (td) {
          txtValue = td.textContent || td.innerText
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = ''
          } else {
            tr[i].style.display = 'none'
          }
        }
      }
    },
    seachbyNIC() {
      var input, filter, table, tr, td, i, txtValue
      input = document.getElementById('myInput')
      filter = input.value.toUpperCase()
      table = document.getElementById('TableList')
      tr = table.getElementsByTagName('tr')
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName('td')[2]
        if (td) {
          txtValue = td.textContent || td.innerText
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = ''
          } else {
            tr[i].style.display = 'none'
          }
        }
      }
    },
  },
}
</script>
